// 首页编委会展示遍历姓氏
export const HOME_COMMITTEE_SURNAME_LIST = ["赵", "王", "张"]


// 通知类型
export const NOTICE_TYPE = {
  // "通知详情"
  NOTICE: 1,
  // "企业详情"
  ENTERPRISE: 2,
  // "轮播图详情"
  SLIDER: 3,
}